import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  LinearProgress,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import InboxIcon from "@mui/icons-material/Inbox";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

const PackageServicesDetails = ({ data }) => {
  // --- EMPTY STATE ---
  if (!data || data.length === 0) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          minHeight: "300px",
          background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
          borderRadius: "20px",
          border: "1px dashed #e2e8f0",
          mt: 2,
          p: 3,
        }}
      >
        <Box sx={{ p: 3, borderRadius: "50%", bgcolor: "#f1f5f9", mb: 2 }}>
          <InboxIcon sx={{ fontSize: 40, color: "#94a3b8" }} />
        </Box>
        <Typography variant="h6" sx={{ color: "#475569", fontWeight: 600 }}>
          No Services Found
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No active services or sessions to display for this event.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", p: 1 }}>


      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          borderRadius: "16px",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        <Table sx={{ width: "100%" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f8fafc" }}>
              {[
                "Service Name",
                "Duration",
                "Days",
                "CLR Status",
                "Professionals",
              ].map((head) => (
                <TableCell
                  key={head}
                  sx={{
                    fontWeight: 700,
                    color: "#64748b",
                    py: 2.5,
                    fontSize: "0.85rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item, index) => {
              const progress =
                item.total_clr > 0
                  ? Math.round((item.completed_clr / item.total_clr) * 100)
                  : 0;
              const profs = item.professionals || item.professsionals || [];

              return (
                <TableRow
                  key={index}
                  hover
                  sx={{ "&:hover": { bgcolor: "#fcfcfc" } }}
                >
                  <TableCell sx={{ py: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          bgcolor: "#dcfce7",
                          p: 1.5,
                          borderRadius: "12px",
                          display: "flex",
                        }}
                      >
                        <MedicalServicesIcon
                          sx={{ color: "#166534", fontSize: "20px" }}
                        />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: "#0f172a",
                            fontSize: "0.95rem",
                          }}
                        >
                          {item.service_name}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "#64748b", fontWeight: 500 }}
                        >
                          {item.sub_service_name}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Typography
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: 600,
                        color: "#334155",
                      }}
                    >
                      {item.startdate}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                      To {item.enddate}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ fontWeight: 600, color: "#334155" }}>
                    {/* {item.duration} Days */}
                    {item.duration} {item.duration === 1 ? "Day" : "Days"}
                  </TableCell>

                  <TableCell sx={{ width: "22%" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 0.8,
                      }}
                    >
                      <Typography
                        variant="caption"
                        fontWeight={700}
                        color={progress === 100 ? "#16a34a" : "#2563eb"}
                      >
                        {progress}%
                      </Typography>
                      <Typography
                        variant="caption"
                        fontWeight={700}
                        color="#64748b"
                      >
                        {item.completed_clr}/{item.total_clr}
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={progress}
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        bgcolor: "#e2e8f0",
                        "& .MuiLinearProgress-bar": {
                          borderRadius: 4,
                          bgcolor: progress === 100 ? "#22c55e" : "#3b82f6",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell sx={{ textAlign: "left", verticalAlign: "top" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 0.8,
                        width: "100%",
                      }}
                    >
                      {profs.filter((p) => p !== null && p !== undefined && String(p).trim() !== "").length > 0 ? (
                        profs
                          .filter(
                            (p) =>
                              p !== null &&
                              p !== undefined &&
                              String(p).trim() !== ""
                          )
                          .map((p, i) => (
                            <Chip
                              key={i}
                              label={p}
                              size="small"
                              icon={
                                <PersonOutlineIcon
                                  sx={{ fontSize: "14px !important" }}
                                />
                              }
                              sx={{
                                bgcolor: "#f1f5f9",
                                color: "#475569",
                                fontWeight: 600,
                                borderRadius: "8px",
                                justifyContent: "flex-start",
                                "& .MuiChip-label": {
                                  textAlign: "left",
                                  paddingLeft: "6px",
                                },
                                "& .MuiChip-icon": {
                                  color: "#64748b",
                                },
                              }}
                            />
                          ))
                      ) : (
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#94a3b8",
                            textAlign: "left",
                          }}
                        >
                          Unassigned
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PackageServicesDetails;
